import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import Theme from "../../assets/Theme";
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ModalTravelInformation from '../ResultsPagePasses/partials/ModalTravelInformation';
import SegmentsFilter from './partials/SegmentFilter';
import DetailRatePasses from './partials/DetailRatePasses';
import ResumeSearch from '../../components/ResumeSearch';
import SegmentTitle from './partials/SegmentTitle';
import { AppBar, Tabs, Tab } from '@material-ui/core';
import { Card, CardHeader, CardContent, Container, Avatar, Grid, Collapse, Button, IconButton, Typography, Hidden, Icon, Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
import moment from 'moment';
import { addAction } from "../../store/actions/index";
import NumberFormat from 'react-number-format';
import Preload from '../../components/Preload';
import { Redirect } from "react-router-dom";
import SearchTrainsPasses from '../../forms/SearchTrainsPasses';
import RawMarkup from '../../components/RawMarkup';
import Image from './../../components/Image'
var Scroll = require('react-scroll');
var Element = Scroll.Element;
var scroller = Scroll.scroller;

class ResultPagePasses extends Component {

    constructor(props) {
        super(props)
        sessionStorage.removeItem("typeProduct");
        sessionStorage.setItem("typeProduct", "passes");
        this.tokenClient = this.props.match.params.token
        this.config = require(`../../store/config/${this.tokenClient}/config.json`);

        this.state = {
            filterText: 'BEST_PRICE',
            pricesItem: this.props.pricesItem,
            totalPrice: this.props.totalPrice,
            idPrice: this.props.idPrice,

            // array primer opcionn/offer Product
            resultsProductKey: [],
            // backup de resultsProductKey resolver el componentDidUpdate y el handleChangeDaysTaken
            resultsProductKeyClone: [],

            priceButtonSelection: [],
            ages: props.match.params.ages.split('-')
        };
        this.nodePrice = this.config.pricing.search
        this.handleChangeDaysTaken = this.handleChangeDaysTaken.bind(this);
        this.handleSelectPrice = this.handleSelectPrice.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.resultsProductKeyClone !== this.props.firstKeyProductsOffer) {
            this.setState({
                priceButtonSelection: [],
                resultsProductKey: this.props.firstKeyProductsOffer,
                resultsProductKeyClone: this.props.firstKeyProductsOffer
            });
        }
    }

    handleChangeDaysTaken = (event, data) => {
        this.setState(state => {
            const resultsProductKey = state.resultsProductKey.map((item, j) => {
                if (j === data) {
                    return event.target.value;
                } else {
                    return item;
                }
            });
            return {
                resultsProductKey,
            };
        });
        this.setState({ priceButtonSelection: [] });
    }

    handleSelectPrice = (e, index, product, data) => {
        this.setState(prevState => ({
            priceButtonSelection: {
                ...prevState.priceButtonSelection,
                index: index,
                product: product,
                data: data,
            }
        }))
        scroller.scrollTo('myScrollToElement', {
            duration: 700,
            delay: 100,
            smooth: true,
            offset: 0
        })
    }

    render() {
        let config = this.config
        var preloadResult = sessionStorage.getItem("preloadResult");

        const SearchContainer = (props) => {
            const [expanded, setExpanded] = React.useState(false)
            const handleExpandClick = () => setExpanded(!expanded)

            return (
                <div className={`result_search_container`}>
                    <div className="form-inverse">
                        <div className="page-maxwidth resume-mobile">
                            <Container maxWidth="xl">
                                <ResumeSearch searchData={this.props?.results} handleExpandClick={handleExpandClick} expanded={expanded} />
                            </Container>
                        </div>
                    </div>
                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                        <div className="result_search_form">
                            <div className="page-maxwidth">
                                <Container maxWidth="xl">
                                    <SearchTrainsPasses
                                        legsPrueba={this.state.legs}
                                        apiToken={config.credential.api.tokenPasses}
                                        searchData={this.props?.results ? true : false}
                                        selectedIatafrom={this.props.results.descriptionCode.key ? this.props.results.descriptionCode.key : ''}
                                    />
                                </Container>
                            </div>
                        </div>
                    </Collapse>
                </div>
            )
        }

        const HeaderRow = (props) => {

            return (
                <div className="headerInfo">
                    <Grid container spacing={1}>
                        <Grid item md={12}>
                            <div className="infoTravel">
                                <span className="separador">
                                    <span className="material-icons">train</span>
                                    <span className="texto">Destino: <strong>{this.props.results.descriptionCode.description}</strong></span>
                                </span>
                                <span className="separador">
                                    <span className="material-icons">date_range</span>
                                    <span className="texto">Válido desde: <strong>

                                        {moment(this.props.results.search.validityStartDate).locale('es').format('dddd, Do MMM YY').replace('º', '')}</strong>
                                    </span>
                                </span>
                            </div>
                            <Typography variant="h2" className="title">
                                Elige una tarifa para tu pase
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            );
        }


        const ContainerSegment = ({ products, filterText, onFilterTextChange }) => {
            return (
                <div className="segmentRateCategoryRow content-results">
                    <div className="white-content">
                        <HeaderRow destiny={this.props.results.search} date={"indexSegment"} />
                        <div className="content-results-table">
                            <Hidden smDown>
                                <div className="text-center containerHeaderTable">
                                    <Grid container>
                                        <Grid item xs={9}>
                                            <div className="tableHeader headerPase" style={{}}>Pase</div>
                                            <div className="tableHeader headerHorarios" style={{}}>Duración</div>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <div className="row-labels">
                                                <Grid container>
                                                    <Grid item xs><div className="tableHeader headerPrecios">Standard</div></Grid>
                                                    <Grid item xs><div className="tableHeader headerPrecios">Comfort</div></Grid>
                                                </Grid>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Hidden>
                            {/* {products && products.length > 0 && this.state.resultsProductKey.length > 0 && products.map((product, index) => { */}
                            {products.length > 0 && products.map((product, index) => {
                                let offer = product.offersDescription[this.state.resultsProductKey[index]] === undefined ? null : product.offersDescription[this.state.resultsProductKey[index]];

                                return (offer !== null &&
                                    <Fragment key={index}>
                                        <div className={`containerProduct ${(index % 2 == 0) ? 'inpar' : 'par'}`}>
                                            <Grid container spacing={1}>
                                                <Grid item md={9}>
                                                    <div className="containerFlex">
                                                        <div className="columnProductoInfo" style={{ display: "inline-block", width: "65%" }}>
                                                            <div>
                                                                <span><Image img={`passesCompany${product.supplier}.svg`} alt="ss" className="imgLogo" /></span>
                                                                <span className="productTitle"><strong> {product.label}</strong></span>
                                                            </div>
                                                            <div className="productConditions">
                                                                {offer.globalConditions.map((condition, i) => {
                                                                    //condition.condition.includes('<p><br></p>')
                                                                    var emptyP = '<p><br></p>'
                                                                    var emptyP2 = '<p><br>'
                                                                    var emptyPx5 = '<p><br><br><br><br><br></p>'
                                                                    var finalCondition = condition.condition.replaceAll(emptyP, '').replaceAll(emptyPx5, '').replaceAll(emptyP2, '<p>');
                                                                    return (
                                                                        <RawMarkup key={i} content={finalCondition} />
                                                                    )
                                                                })}
                                                            </div>
                                                            <div>
                                                                <ModalTravelInformation
                                                                    conditions={offer.conditions}
                                                                    title={product.label}
                                                                    ages={this.state.ages.some(age => age <= 5)}
                                                                    page="passes"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="columnProductoSelectDays" style={{ display: "inline-block", width: "35%" }}>
                                                            <div className="timeInfo">
                                                                <div><strong>{offer.periodType.description}</strong></div>
                                                                <div>Desde: <span> {moment(offer.activationPeriod.startDate).locale('es').format('dddd, Do MMM YY').replace('º', '')}</span></div>
                                                                <div>Hasta: <span> {moment(offer.activationPeriod.endDate).locale('es').format('dddd, Do MMM YY').replace('º', '')}</span></div>
                                                            </div>
                                                            <div className="selectDays">
                                                                <FormControl variant="outlined" fullWidth className={"InputForm"}>
                                                                    <InputLabel id="demo-simple-select-outlined-label" shrink><strong>Cantidad de días:</strong></InputLabel>
                                                                    <Select
                                                                        labelId="oringinSelect"
                                                                        id={`destinationSelect-${index}`}
                                                                        value={this.state.resultsProductKey[index]}
                                                                        onChange={(e) => this.handleChangeDaysTaken(e, index)}
                                                                        label=""
                                                                    >
                                                                        {product.durations.map((duration, i) =>
                                                                            <MenuItem key={i} value={duration.key}>{duration.description}</MenuItem >
                                                                        )}
                                                                    </Select>
                                                                </FormControl>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item md={3}>
                                                    <Grid container spacing={1} className="columnPriceButtons">
                                                        <Grid item xs>
                                                            {offer.travelClass.map((selectPrice, i) => {
                                                                if (selectPrice.category.code === 'STANDARD')
                                                                    return (
                                                                        <Button
                                                                            key={i}
                                                                            fullWidth
                                                                            size="small"
                                                                            className={`offerButton  ${index == this.state.priceButtonSelection.index && selectPrice.id == this.state.priceButtonSelection.data.id && 'selected'}`}
                                                                            variant="contained" color="default"
                                                                            onClick={(e) => this.handleSelectPrice(e, index, this.state.resultsProductKey[index], selectPrice)}
                                                                        >
                                                                            {this.config.credential.currency} {selectPrice.api.values.search_price.toFixed(0)}
                                                                        </Button>
                                                                    )
                                                            })}
                                                        </Grid>
                                                        <Grid item xs>
                                                            {offer.travelClass.map((selectPrice, i) => {
                                                                if (selectPrice.category.code === 'COMFORT')
                                                                    return (
                                                                        <Button
                                                                            key={i}
                                                                            fullWidth
                                                                            size="small"
                                                                            className={`offerButton  ${index == this.state.priceButtonSelection.index && selectPrice.id == this.state.priceButtonSelection.data.id && 'selected'}`}
                                                                            variant="contained" color="default"
                                                                            onClick={(e) => this.handleSelectPrice(e, index, this.state.resultsProductKey[index], selectPrice)}
                                                                        >
                                                                            {this.config.credential.currency} {selectPrice.api.values.search_price.toFixed(0)}
                                                                        </Button>
                                                                    )
                                                            })}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </Fragment>
                                )
                            })}
                        </div>
                    </div>
                </div>
            )
        }

        const MainContent = () => {
            return (
                <main className={`main_content`}>
                    <div className="page-maxwidth">
                        <Container maxWidth="xl">
                            <Grid container spacing={1}>
                                <Element name="myScrollToElement"></Element>
                                <Hidden mdUp>
                                    <Grid item xs={12}>
                                        <DetailRatePasses
                                            selectedProduct={this.props.results.products[this.state.priceButtonSelection.index]}
                                            selectedPrice={this.state.priceButtonSelection.data}
                                            selectedSearchDate={this.props.results.search.validityStartDate}
                                            selectedSearchDestinyDescription={this.props.results.descriptionCode.description}
                                            descriptionCode={this.props.results.descriptionCode}
                                            isEmptyCart={this.state.priceButtonSelection.length == 0 ? false : true}
                                            tokenClient={this.tokenClient}
                                            priceButtonSelection={this.state.priceButtonSelection}
                                            itemsCart={this.props.itemsCart}
                                            xCorrelationId={this.props.results.x_correlation_id}
                                            ages={this.state.ages.some(age => age <= 5)}
                                        />
                                    </Grid>
                                </Hidden>

                                <Grid item md={9}>
                                    <SegmentsFilter
                                        filterText={this.state?.filterText}
                                    />
                                    <ContainerSegment
                                        products={this.props.results.products}
                                        filterText={this.state?.filterText}
                                    />
                                </Grid>
                                <Hidden smDown>
                                    <Grid item md={3}>
                                        <DetailRatePasses
                                            selectedProduct={this.props.results.products[this.state.priceButtonSelection.index]}
                                            selectedPrice={this.state.priceButtonSelection.data}
                                            selectedSearchDate={this.props.results.search.validityStartDate}
                                            selectedSearchDestinyDescription={this.props.results.descriptionCode.description}
                                            descriptionCode={this.props.results.descriptionCode}
                                            isEmptyCart={this.state.priceButtonSelection.length == 0 ? false : true}
                                            tokenClient={this.tokenClient}
                                            priceButtonSelection={this.state.priceButtonSelection}
                                            itemsCart={this.props.itemsCart}
                                            xCorrelationId={this.props.results.x_correlation_id}
                                            ages={this.state.ages.some(age => age <= 5)}
                                        />
                                    </Grid>
                                </Hidden>

                            </Grid>
                        </Container>
                    </div>
                </main>
            )
        }

        return (
            <Theme>
                <div className={`wrapper results ${preloadResult ? 'has-preload' : ''}`} styles={config.styles}>
                    <Header 
                    isLogin={config.credential.isLogin} 
                    client={config.client} 
                    header={config.header} 
                    misReservas={config.misReservas}
                    />
                    {preloadResult !== null ?

                        (<Preload typeTrainSearch="pase" />) : (this.props.results.products === undefined || this.props.results.products.length < 1) ? (
                            (<Redirect to={{ pathname: `/${this.tokenClient}/trenes/`, state: { stateError: true } }} exact />)
                        ) : (Object.keys(this.props.results).length > 0) ?
                            (<Fragment>
                                <SearchContainer />
                                <MainContent />
                            </Fragment>) :
                            (<Redirect to={{ pathname: `/${this.tokenClient}/trenes/` }} exact />)
                    }
                    <Footer data={config.footer} client={config.client} />
                </div>
            </Theme>
        )
    }

}

const mapStateToProps = reducers => {
    return reducers.searchReducer
};

const mapDispatchToProps = dispatch => {
    return {
        dispatchAddAction: (itemsCart, totalPrice, idPrice, pricesItem, segmentState) => { dispatch(addAction(itemsCart, totalPrice, idPrice, pricesItem, segmentState)) },
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ResultPagePasses);

